import { render, staticRenderFns } from "./BarcodeInput.vue?vue&type=template&id=0c2a08c4"
import script from "./BarcodeInput.vue?vue&type=script&lang=js"
export * from "./BarcodeInput.vue?vue&type=script&lang=js"
import style0 from "./BarcodeInput.vue?vue&type=style&index=0&id=0c2a08c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports